(function(){
  if(window.__lpQV)return;window.__lpQV=1;
  function money(c){return new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(c/100);}
  function data(p){if(!p.__d){try{p.__d=JSON.parse(p.querySelector('[data-qv-json]').textContent);}catch(e){p.__d=[];}}return p.__d;}
  function sel(p){return Array.prototype.map.call(p.querySelectorAll('.qv__group'),function(g){var c=g.querySelector('input:checked');return c?c.value:null;});}
  function cur(p){var o=sel(p);return data(p).find(function(v){return v.o.every(function(x,i){return x===o[i];});});}
  function upd(p){
    var o=sel(p);
    p.querySelectorAll('.qv__group').forEach(function(g,i){
      var l=g.querySelector('[data-qv-val]');if(l)l.textContent=o[i];
      g.querySelectorAll('.qv__val').forEach(function(lab){
        var val=lab.querySelector('input').value;
        var t=o.slice();t[i]=val;
        var v=data(p).find(function(x){return x.o.every(function(y,k){return y===t[k];});});
        lab.classList.toggle('is-out',!v||!v.a);
      });
    });
    var v=cur(p),q=parseInt(p.querySelector('[data-qv-q]').textContent,10)||1,b=p.querySelector('[data-qv-add]');
    var img=p.querySelector('[data-qv-img]'),nm=p.querySelector('[data-qv-name]');
    if(v&&nm)nm.textContent=v.t;
    if(v&&img&&v.i&&img.getAttribute('src')!==v.i)img.setAttribute('src',v.i);
    if(!v||!v.a){b.disabled=true;b.textContent='Uitverkocht';return;}
    b.disabled=false;b.innerHTML='In winkelwagen &ndash; '+money(v.p*q);b.dataset.id=v.id;
  }
  function closeAll(){document.querySelectorAll('.qv:not([hidden])').forEach(function(p){p.hidden=true;});}
  function openP(p){closeAll();p.hidden=false;upd(p);}
  async function add(p,btn){
    var q=parseInt(p.querySelector('[data-qv-q]').textContent,10)||1,T=window.theme||{},R=T.routes||{};
    var drawer=document.getElementById('CartDrawer'),use=T.cartType==='drawer'&&drawer;
    btn.classList.add('is-loading');
    try{
      var body={items:[{id:parseInt(btn.dataset.id,10),quantity:q}]};if(use)body.sections='cart-drawer';
      var r=await fetch((R.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
      var d=await r.json();
      if(!r.ok||d.status){btn.textContent=d.description||d.message||'Fout';return;}
      if(!use){location.href=R.cart||'/cart';return;}
      if(d.sections&&d.sections['cart-drawer']){
        var doc=new DOMParser().parseFromString(d.sections['cart-drawer'],'text/html'),f=doc.getElementById('CartDrawer');
        if(f)drawer.innerHTML=f.innerHTML;
      }
      var c=await (await fetch((R.cart||'/cart')+'.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count>0?c.item_count:'';});
      closeAll();
      var t=document.createElement('button');t.setAttribute('data-drawer-open','CartDrawer');t.hidden=true;document.body.appendChild(t);t.click();t.remove();
    }catch(e){btn.textContent='Fout, probeer opnieuw';}
    finally{btn.classList.remove('is-loading');}
  }
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-qv-open]');
    if(o){e.preventDefault();var p=o.closest('.card').querySelector('.qv');if(p){if(p.hidden)openP(p);else closeAll();}return;}
    if(e.target.closest('[data-qv-close]')){e.preventDefault();closeAll();return;}
    var p=e.target.closest('.qv');
    if(p){
      var q=p.querySelector('[data-qv-q]');
      if(e.target.closest('[data-qv-plus]')){q.textContent=Math.min(99,(parseInt(q.textContent,10)||1)+1);upd(p);}
      else if(e.target.closest('[data-qv-minus]')){q.textContent=Math.max(1,(parseInt(q.textContent,10)||1)-1);upd(p);}
      else if(e.target.closest('[data-qv-add]')){e.preventDefault();add(p,e.target.closest('[data-qv-add]'));}
      return;
    }
    if(!e.target.closest('.card'))closeAll();
  });
  document.addEventListener('change',function(e){var p=e.target.closest('.qv');if(p)upd(p);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
})();